import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ManualConfigurationPage } from './manual-configuration.page';

const routes: Routes = [
  {
    path: '',
    component: ManualConfigurationPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManualConfigurationPageRoutingModule {}
